import { createAction, props } from '@ngrx/store';
import { DocumentDetailsMetaEntity } from './document-details-meta.models';

export const initDocumentDetailsMeta = createAction(
  '[Document Details Meta Info] Get document details meta info',
  props<{ categoryId: number; documentId: number; language: string }>()
);

export const loadDocumentDetailsMetaSuccess = createAction(
  '[Document Details Meta Info] Load Document Details Meta Info Success',
  props<{ documentDetailsMeta: DocumentDetailsMetaEntity }>()
);

export const loadDocumentDetailsMetaFailure = createAction(
  '[Document Details Meta Info] Load Document Details Meta Info Failure',
  props<{ error: string }>()
);

export const clearDocumentDetailsMeta = createAction('[Document Details Meta Info] Clear Document Details Meta Info');
